(() => {
  const setup = () => {
    document.querySelectorAll('[data-skr-reviews]').forEach((root) => {
      if (root.dataset.skrReady === 'true') return;
      root.dataset.skrReady = 'true';
      const text = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
      const enhance = () => {
        const widget = root.querySelector('.jdgm-rev-widg');
        if (!widget) return;
        const count = Number(widget.getAttribute('data-number-of-reviews'));
        const rating = Number(widget.getAttribute('data-average-rating'));
        if (!Number.isInteger(count) || count < 0 || !Number.isFinite(rating) || rating < 0 || rating > 5) return;
        const summaryLabel = (count === 1 ? root.dataset.summaryOne : root.dataset.summaryMany).replace('__COUNT__', String(count));
        const countNode = root.querySelector('[data-skr-review-count]');
        text(countNode, (count === 1 ? root.dataset.countOne : root.dataset.countMany).replace('__COUNT__', String(count)));
        countNode.hidden = false;
        root.dataset.empty = String(count === 0);
        root.querySelector('[data-skr-reviews-empty]').hidden = count !== 0;
        text(widget.querySelector('.jdgm-rev-widg__title'), root.dataset.title);
        text(widget.querySelector('.jdgm-rev-widg__summary-text'), summaryLabel);
        text(widget.querySelector('.jdgm-write-rev-link'), root.dataset.writeLabel);
        widget.querySelectorAll('.jdgm-rev__reply').forEach((reply) => {
          reply.hidden = !reply.textContent.trim() && !reply.querySelector('img, video');
        });
        const summary = widget.querySelector('.jdgm-rev-widg__summary');
        if (summary && count > 0) {
          let score = summary.querySelector('.skr-reviews__score');
          if (!score) {
            score = document.createElement('div');
            score.className = 'skr-reviews__score';
            const number = document.createElement('span');
            const scale = document.createElement('small');
            scale.textContent = '/ 5';
            score.append(number, scale);
            summary.prepend(score);
          }
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'nl', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(rating);
          text(score.querySelector('span'), formatted);
          score.setAttribute('aria-label', root.dataset.ratingLabel.replace('__RATING__', formatted));
        }
        widget.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach((row) => {
          const value = Number(row.getAttribute('data-rating'));
          const button = row.querySelector('.jdgm-histogram__star');
          if (button && value >= 1 && value <= 5) button.setAttribute('aria-label', root.dataset.starLabel.replace('__COUNT__', String(value)));
        });
        document.querySelectorAll('.skr-product--compact .jdgm-prev-badge').forEach((badge) => {
          if (badge.dataset.skrReviewLink === 'true') return;
          badge.dataset.skrReviewLink = 'true';
          badge.setAttribute('role', 'link');
          badge.setAttribute('tabindex', '0');
          badge.setAttribute('aria-label', root.dataset.viewLabel);
          const stars = badge.querySelector('.jdgm-prev-badge__stars');
          if (stars) { stars.setAttribute('role', 'img'); stars.removeAttribute('tabindex'); }
          const go = () => root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
          badge.addEventListener('click', go);
          badge.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); go(); }
          });
        });
      };
      enhance();
      let pending = false;
      const observer = new MutationObserver(() => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; enhance(); });
      });
      observer.observe(root, { childList: true, subtree: true });
      const panel = document.querySelector('.skr-product--compact .skr-product__panel');
      if (panel) observer.observe(panel, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
